<mat-card appearance="outlined" class="gap-flex-12 card" appActionable (click)="!isDisabled && openDialog(modalTemplate)">
  <div class="flex-row gap-flex-12 summary-header-container">
    <app-svg-icon class="summary-icon" [path]="src" />
    <div class="flex-column gap-flex-2">
      <app-field-label [label]="title" [tooltip]="cardTooltip" [labelClass]="'text-muted-md'"></app-field-label>
      <span class="text-muted-xs">{{ subtitle }}</span>
    </div>
  </div>
  <mat-card-content class="flex-column gap-flex-8">
    <span class="brand-heading-text">{{ value | number }}</span>
    <span>{{ trend }}</span>
  </mat-card-content>
</mat-card>

<ng-template #totalSites>
  <div class="gap-flex-24 flex-column dialog-content">
    <div class="flex-row">
      <span class="navigation-button text-muted-sm" appActionable (click)="closeModal()">Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="brand-text-sm">{{ title }}</span>
    </div>

    <mat-card appearance="outlined" class="modal-card">
      <mat-card-content class="flex-column gap-flex-8">
        <span class="brand-text-2xl">{{ customersData.length | number }}</span>
        <span class="text-muted-sm">{{ customersData.length | number }} venues requiring attention</span>
      </mat-card-content>
    </mat-card>

    <div>
      <mat-card appearance="outlined" class="header-modal">
        <mat-card-content class="flex-column gap-flex-8">
          <span class="brand-text-lg">Affected Venues</span>
        </mat-card-content>
      </mat-card>
      <igx-grid class="modal-table clickable-rows" [data]="customersData" [autoGenerate]="false"
        [height]="'Auto'" [emptyGridMessage]="'No data available'" (rowClick)="openCustomerDetails($event)"
        (gridKeydown)="onGridKeydown($event)">
        <igx-column *ngFor="let col of modalSiteColumns" [field]="col.field" [header]="col.header" [width]="col.width" [minWidth]="col.minWidth ?? '120px'"
          [sortable]="col.sortable ?? false" [sortStrategy]="sortStrategyFor(col)">
          <ng-template igxCell let-cell="cell">
            <span [class.brand-text-sm]="col.type === 'label'">{{ cell.value || '-' }}</span>
          </ng-template>
        </igx-column>
      </igx-grid>
    </div>
  </div>
</ng-template>

<ng-template #activeWorkstation>
  <div class="gap-flex-24 flex-column dialog-content">
    <div class="flex-row">
      <span class="navigation-button text-muted-sm" appActionable (click)="closeModal()">Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="brand-text-sm">{{ title }}</span>
    </div>

    <mat-card appearance="outlined" class="modal-card">
      <mat-card-content class="flex-column gap-flex-8">
        <span class="brand-text-2xl">{{ customersData.length | number }}</span>
        <span class="text-muted-sm">{{ customersData.length | number }} venues requiring attention</span>
      </mat-card-content>
    </mat-card>

    <div>
      <mat-card appearance="outlined" class="header-modal">
        <mat-card-content class="flex-column gap-flex-8">
          <span class="brand-text-lg">Affected Venues</span>
        </mat-card-content>
      </mat-card>
      <igx-grid class="modal-table clickable-rows" [data]="customersData" [autoGenerate]="false"
        [height]="'Auto'" [emptyGridMessage]="'No data available'" (rowClick)="openCustomerDetails($event)"
        (gridKeydown)="onGridKeydown($event)">
        <igx-column *ngFor="let col of modalSiteColumns" [field]="col.field" [header]="col.header" [width]="col.width" [minWidth]="col.minWidth ?? '120px'"
          [sortable]="col.sortable ?? false" [sortStrategy]="sortStrategyFor(col)">
          <ng-template igxCell let-cell="cell">
            <span [class.brand-text-sm]="col.type === 'label'">{{ cell.value || '-' }}</span>
          </ng-template>
        </igx-column>
      </igx-grid>
    </div>
  </div>
</ng-template>

<ng-template #backupCompliance>
  <div class="gap-flex-24 flex-column dialog-content">
    <div class="flex-row">
      <span class="navigation-button text-muted-sm" appActionable (click)="closeModal()">Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="brand-text-sm">{{ title }}</span>
    </div>

    <mat-card appearance="outlined" class="modal-card">
      <mat-card-content class="flex-column gap-flex-8">
        <span class="brand-text-2xl">{{ customersData.length | number }}</span>
        <span class="text-muted-sm">{{ customersData.length | number }} venues requiring attention</span>
      </mat-card-content>
    </mat-card>

    <div>
      <mat-card appearance="outlined" class="header-modal">
        <mat-card-content class="flex-column gap-flex-8">
          <span class="brand-text-lg">Affected Venues</span>
        </mat-card-content>
      </mat-card>
      <igx-grid class="modal-table clickable-rows" [data]="customersData" [autoGenerate]="false"
        [height]="'Auto'" [emptyGridMessage]="'No data available'" (rowClick)="openCustomerDetails($event)"
        (gridKeydown)="onGridKeydown($event)">
        <igx-column *ngFor="let col of modalSiteColumns" [field]="col.field" [header]="col.header" [width]="col.width" [minWidth]="col.minWidth ?? '120px'"
          [sortable]="col.sortable ?? false" [sortStrategy]="sortStrategyFor(col)">
          <ng-template igxCell let-cell="cell">
            <span [class.brand-text-sm]="col.type === 'label'">{{ cell.value || '-' }}</span>
          </ng-template>
        </igx-column>
      </igx-grid>
    </div>
  </div>
</ng-template>

<ng-template #systemAlerts>
  <div class="gap-flex-24 flex-column dialog-content">
    <div class="flex-row">
      <span class="navigation-button text-muted-sm" appActionable (click)="closeModal()">Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="brand-text-sm">{{ title }}</span>
    </div>

    <mat-card appearance="outlined" class="modal-card">
      <mat-card-content class="flex-column gap-flex-8">
        <span class="brand-text-2xl">{{ customersData.length | number }}</span>
        <span class="text-muted-sm">{{ customersData.length | number }} venues requiring attention</span>
      </mat-card-content>
    </mat-card>

    <div>
      <mat-card appearance="outlined" class="header-modal">
        <mat-card-content class="flex-column gap-flex-8">
          <span class="brand-text-lg">Affected Venues</span>
        </mat-card-content>
      </mat-card>
      <igx-grid class="modal-table clickable-rows" [data]="customersData" [autoGenerate]="false"
        [height]="'Auto'" [emptyGridMessage]="'No data available'" (rowClick)="openCustomerDetails($event)"
        (gridKeydown)="onGridKeydown($event)">
        <igx-column *ngFor="let col of modalSiteColumns" [field]="col.field" [header]="col.header" [width]="col.width" [minWidth]="col.minWidth ?? '120px'"
          [sortable]="col.sortable ?? false" [sortStrategy]="sortStrategyFor(col)">
          <ng-template igxCell let-cell="cell">
            <span [class.brand-text-sm]="col.type === 'label'">{{ cell.value || '-' }}</span>
          </ng-template>
        </igx-column>
      </igx-grid>
    </div>
  </div>
</ng-template>

<ng-template #sqlLimits>
  <div class="gap-flex-24 flex-column dialog-content">
    <div class="flex-row">
      <span class="navigation-button text-muted-sm" appActionable (click)="closeModal()">Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="brand-text-sm">{{ title }}</span>
    </div>

    <mat-card appearance="outlined" class="modal-card">
      <mat-card-content class="flex-column gap-flex-8">
        <span class="brand-text-2xl">{{ customersData.length | number }}</span>
        <span class="text-muted-sm">{{ customersData.length | number }} venues requiring attention</span>
      </mat-card-content>
    </mat-card>

    <div>
      <mat-card appearance="outlined" class="header-modal">
        <mat-card-content class="flex-column gap-flex-8">
          <span class="brand-text-lg">Affected Venues</span>
        </mat-card-content>
      </mat-card>
      <igx-grid class="modal-table clickable-rows" [data]="customersData" [autoGenerate]="false"
        [height]="'Auto'" [emptyGridMessage]="'No data available'" (rowClick)="openCustomerDetails($event)"
        (gridKeydown)="onGridKeydown($event)">
        <igx-column *ngFor="let col of modalSqlColumns" [field]="col.field" [header]="col.header" [width]="col.width" [minWidth]="col.minWidth ?? '120px'"
          [sortable]="col.sortable ?? false" [sortStrategy]="sortStrategyFor(col)">
          <ng-template igxCell let-cell="cell">
            <ng-container [ngSwitch]="col.type">
              <span *ngSwitchCase="'label'" class="brand-text-sm">{{ cell.value || '-' }}</span>
              <ng-container *ngSwitchCase="'dbStatus'">
                @let s = getDbStatus(cell.row.data);
                <mat-chip selected [ngClass]="s.chipClass">{{ s.status }}</mat-chip>
              </ng-container>
              <ng-container *ngSwitchCase="'dbSizeText'">
                @let s = getDbStatus(cell.row.data);
                <span [class]="s.className">{{ cell.value || '-' }}</span>
              </ng-container>
              <span *ngSwitchDefault>{{ cell.value || '-' }}</span>
            </ng-container>
          </ng-template>
        </igx-column>
      </igx-grid>
    </div>
  </div>
</ng-template>